<template>
  <z-form-group v-if="formatted_value.length" class="row">
    <z-form-input class="col-8 offset-4">
      <player-row v-for="file in formatted_value" :key="file.sln_file" :file="file">
        <table-control slot="controls" type="trash" @click="remove(file.sln_file)" />
      </player-row>
    </z-form-input>
  </z-form-group>
</template>

<script>
  import PlayerRow from '@pbx/components/media/_fragments/file-player-row';
  import { MediaService } from '@pbx/services/MediaService';

  export default {
    components: { PlayerRow },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        files: []
      };
    },

    computed: {
      formatted_value: function() {
        return this.value.map(file => this.get_file(file)).filter(file => file);
      }
    },

    created() {
      MediaService.getSelect().then(res => (this.files = res));
    },

    methods: {
      get_file: function(sln_file_search) {
        return this.files.find(({ sln_file }) => sln_file === sln_file_search);
      },
      remove: function(search) {
        const new_value = this.value.filter(file => file !== search);
        this.$emit('input', new_value);
      }
    }
  };
</script>
